import React from 'react';
import PropTypes from 'prop-types';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SoftBox from "../../../components/SoftBox";
import SoftTypography from "../../../components/SoftTypography";
import {Grid, Typography} from "@mui/material";

function AdminInfo({admin}) {
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString();
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString();
    };

    const getGenderDisplayName = (gender) => {
        switch (gender) {
            case 'MALE':
                return 'Male';
            case 'FEMALE':
                return 'Female';
            case 'OTHER':
                return 'Other';
            default:
                return 'N/A';
        }
    };

    const getIdTypeDisplayName = (idType) => {
        switch (idType) {
            case 'MYKAD':
                return 'MYKAD';
            case 'PASSPORT':
                return 'Passport';
            case 'DRIVING_LICENSE':
                return 'Driving License';
            default:
                return 'N/A';
        }
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Profile Information
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Email Address
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {admin.email || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Phone Number
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {admin.phoneNumber || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Gender
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {getGenderDisplayName(admin.gender)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Birth Date
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDate(admin.birthDate)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                ID Type
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {getIdTypeDisplayName(admin.idType)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                ID Number
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {admin.idNumber || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Last Login
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDateTime(admin.lastLogin)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Username
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {admin.username || 'N/A'}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Created At
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDateTime(admin.createdAt)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <SoftBox mb={2}>
                            <SoftTypography variant="button" fontWeight="bold" color="text">
                                Updated At
                            </SoftTypography>
                            <SoftTypography variant="body2" color="text">
                                {formatDateTime(admin.updatedAt)}
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

AdminInfo.propTypes = {
    admin: PropTypes.shape({
        email: PropTypes.string,
        phoneNumber: PropTypes.string,
        gender: PropTypes.string,
        birthDate: PropTypes.string,
        idType: PropTypes.string,
        idNumber: PropTypes.string,
        userRole: PropTypes.string,
        status: PropTypes.string,
        lastLogin: PropTypes.string,
        username: PropTypes.string,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
    }).isRequired,
};

export default AdminInfo;
